export const CURRENT_KEY = "rav-current-instant";
export const HISTORY_KEY = "rav-history";

export function saveCurrent(instant) {
  sessionStorage.setItem(CURRENT_KEY, JSON.stringify(instant));
}

export function loadCurrent() {
  try {
    return JSON.parse(sessionStorage.getItem(CURRENT_KEY) || "null");
  } catch {
    return null;
  }
}

export function loadHistory() {
  try {
    return JSON.parse(localStorage.getItem(HISTORY_KEY) || "[]");
  } catch {
    return [];
  }
}

export function saveHistory(list) {
  localStorage.setItem(HISTORY_KEY, JSON.stringify(list));
}

export function addToHistory(entry) {
  const list = loadHistory();
  list.unshift(entry);
  saveHistory(list.slice(0, 100));
}

export const PILLAR_LABELS = {
  respirer: "Respirer",
  nourrir: "Nourrir",
  bouger: "Bouger",
  toucher: "Toucher",
  ressentir: "Ressentir",
};

export function dateLabel(iso) {
  const d = new Date(iso);
  const today = new Date();
  const yesterday = new Date(today);
  yesterday.setDate(today.getDate() - 1);
  const same = (a, b) => a.toDateString() === b.toDateString();
  if (same(d, today)) return "Aujourd'hui";
  if (same(d, yesterday)) return "Hier";
  return d.toLocaleDateString("fr-FR", { day: "numeric", month: "long" });
}
